<template>
<div class="ui segment">
  <category-menu :tempfix="true" ></category-menu>
  
  <!--div style="display: flex; justify-content: space-between; width:100%; max-height: 250px; margin-bottom:50px">
    <a v-for="(item,index) in banners" :href="item.url" :target="item.target"><img :src="item.img" style="width: 100%; height: 100%; object-fit: cover;" /></a>
  </div-->
  
  <link rel="stylesheet" href="https://unpkg.com/simpleslider-js@1.9.0/dist/simpleSlider.min.css" />
  <div class="simple-slider page-slider desktop-slider" style="width:100%; max-height: 250px; margin-bottom: 50px;">
    <div class="slider-wrapper">
      <div v-for="(item,index) in desktopBanners" class="slider-slide" style="max-height: 250px;">
        <a :href="item.url" :target="item.target"><img :src="item.img" style="width: 100%; height: 100%; max-height: 250px; object-fit: contain;" /></a>
      </div>
    </div>
    <div class="slider-pagination"></div>
    <div class="slider-btn slider-btn-prev"></div>
    <div class="slider-btn slider-btn-next"></div> 
  </div>
  <div class="simple-slider page-slider mobile-slider" style="width:100%; max-height: 500px; margin-top: -20px; margin-bottom: 20px;">
    <div class="slider-wrapper">
      <div v-for="(item,index) in mobileBanners" class="slider-slide" style="max-height: 250px;">
        <a :href="item.url" :target="item.target"><img :src="item.img" style="width: 100%; height: 100%; max-height: 250px; object-fit: contain;" /></a>
      </div>
    </div>
    <div class="slider-pagination"></div>
    <div class="slider-btn slider-btn-prev"></div>
    <div class="slider-btn slider-btn-next"></div> 
  </div>

  <!-- cart icon -->
  <div class="fabContainer" v-if="itemsInCart>0">
      <div class="faButton" v-on:click="$router.push({name:'cart'})">
          <div class="fabb ui circular google plus icon button">
              <i class="cart icon"></i>
          </div>
      </div>
  </div>

  <last-ordered-goods v-if="user.role>0 && lastordered && lastordered.length > 0"></last-ordered-goods>
  <top-goods></top-goods>
  <!-- <discounted-goods></discounted-goods> -->
  <new-goods></new-goods>

</div>
</template>

<script>
import LastOrderedGoods from './HomeLastOrderedGoods'
import TopGoods from './HomeTopGoods'
import DiscountedGoods from './HomeDiscountedGoods'
import NewGoods from './HomeNewGoods'
import CategoryMenu from './CategoryMenu'

export default {
  components: {
    LastOrderedGoods,
    TopGoods,
    DiscountedGoods,
    NewGoods,
    CategoryMenu
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App 2'
    }
  },
  computed: {
    user() {
      return this.$store.state.userStore.user
    },
    desktopBanners() {
      return this.$store.state.userStore.banners.filter(i => i.position.startsWith('front_desktop'))
    },
    mobileBanners() {
      return this.$store.state.userStore.banners.filter(i => i.position.startsWith('front_mobile'))
    },
    lastordered() {
      //loaded from parent
      return this.$store.state.goodStore.lastordered
    },
    itemsInCart() {
      const sumValues = Object.keys(this.$store.state.cartStore.items).reduce((acc, value) =>  acc + parseInt(this.$store.state.cartStore.items[value].order), 0);
      return  sumValues
    },
  },
  activated() {
    this.loadActiveCart();
    this.$store.dispatch('loadLastOrderedGoods');
    this.$store.dispatch('loadOrderWaitingForDelivery');
    this.$store.dispatch('loadTopGoods',3);
    this.$store.dispatch('loadNewGoods',3);
    
    window.removeEventListener('scroll', this.handleScroll);
    var header = document.querySelector('#fixed-header');
    if (header) header.style.top = '-100px';
  },
  mounted() {
    var sliderScript = document.createElement('script');
    sliderScript.setAttribute('src', 'https://unpkg.com/simpleslider-js@1.9.0/dist/simpleSlider.min.js');
    document.head.appendChild(sliderScript);
    sliderScript.addEventListener('load', function() {
      new SimpleSlider('.desktop-slider', {
        autoplay: true,
        enableDrag: false
      });
      new SimpleSlider('.mobile-slider', {
        autoplay: true,
        enableDrag: false
      });
    });
    
    var awayTimer;
    window.addEventListener('blur', function(event) {
      awayTimer = performance.now();
      return false;
    });
    window.addEventListener('focus', function(event) {
      if (performance.now() - awayTimer > 600000) { // 10 minutes in milliseconds
        awayTimer = performance.now();
        window.location.reload();
      }
      return false;
    });
  },
  methods: {
    loadActiveCart: function() {
      this.$store.dispatch('loadActiveCart').then((response) => {
        this.$store.dispatch('loadCartItems', this.cart.id);
      }).catch((error) => {
         if(error.response && error.response.status == 404) {
         //if there is no active cart then create new cart
          this.$store.dispatch('createCart').then((response) => {
            this.$store.dispatch('loadCartItems', response.data.data.id);
          }).catch((error) => {

          });
         }
      });
    }
  }
}
</script>


<style>
.fabContainer {
  position: fixed;
  margin-left: 1086px;
  bottom: 50px;
  background: none;
  border: none;
  text-align: right;
  z-index: 10;
}
.fabb.button {
  font-size: 1.5rem !important;
}
.pagination-bullet { box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; }
.simple-slider .slider-btn.slider-btn-prev { background-image: url(../assets/prev.svg) !important; }
.simple-slider .slider-btn.slider-btn-next { background-image: url(../assets/next.svg) !important; }
.mobile-slider { display: none; }
@media (max-width:767px) {
    .mobile-slider { display: block; }
    .desktop-slider { display: none; }
    .fabContainer {
        right: 0px
    }
}
@media (min-width:768px) {
    .fabContainer {
        margin-left: 675px
    }
}
@media (min-width:992px) {
    .fabContainer  {
        margin-left: 895px
    }
}
@media (min-width:1260px) {
    .fabContainer {
        margin-left: 1086px
    }
}
@media (min-width:1280px) {
    .fabContainer {
        margin-left: 1086px
    }
}
</style>



// WEBPACK FOOTER //
// HomePage.vue?2c03d8db